import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ultimateSoftware = defineConnector({
  identifier: "ultimateSoftware",
  name: "Ultimate Software",
  tagLine: "Human capital management",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://.*\\.ultimatesoftware\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Get your Ultimate Software API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your Ultimate Software instance and navigate to **Administration › Web Services** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your Ultimate Software details",
      items: [
        {
          kind: "url",
          label: "Instance URL",
          required: true,
          placeholder: "https://your-instance.ultimatesoftware.com",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "The base URL of your Ultimate Software instance.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://service.ultipro.com/authentication/v1/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api/v1/personnel/employees?limit=1`,
  },
  publicEnvVars: ({ baseUrl }) => ({
    ULTIMATE_SOFTWARE_URL: baseUrl || "",
  }),
});
